import React from 'react'

import TextArea from 'modules/core/components/TextArea'
import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import i18n from 'modules/core/lib/i18n'

import { Element } from 'modules/forms/lib/Element'
import { Answer } from 'modules/forms/lib/types'

interface TextElementQuestionProps {
  element: Element
  onChange?: (answer: Answer) => void
  disabled?: boolean
}

/**
 * Editor component for TextElement
 */
const TextElementQuestion: React.FC<TextElementQuestionProps> = ({
  element,
  onChange,
  disabled,
}) => {
  const currentValue = element.answer ? element.answer.answer : undefined
  const [value, setValue] = React.useState<string | undefined>(currentValue)

  useUnsafeEffect(() => {
    setValue(currentValue)
  }, [element.id, currentValue])

  const handleOnChange = (newValue: string) => {
    setValue(newValue)
    onChange?.({ answer: newValue })
  }

  const hasAttemptedSubmit = false // TODO

  const getError = () => {
    if (hasAttemptedSubmit) {
      if (element.mandatory && !value) {
        return i18n.t('forms.render.answer_required')
      }
    }
    return undefined
  }

  return (
    <TextArea
      hideLabel
      label={element.label}
      mandatory={element.mandatory}
      placeholder={i18n.t('forms.render.answer_placeholder')}
      value={value}
      onChange={handleOnChange}
      readonly={disabled}
      error={getError()}
    />
  )
}

export default TextElementQuestion
